import { createGlobalStyle } from 'styled-components';
import theme from './theme';

const GlobalStyles = createGlobalStyle`
  :root {
    --bottom-menu-height: 60px;
    --input-area-height: 50px;
    --header-height: 60px;
    --podium-height: 280px;
    --safe-area-inset-bottom: env(safe-area-inset-bottom, 0px);
    --vh: 1vh;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -webkit-tap-highlight-color: transparent;
  }

  html {
    height: 100%;
    width: 100%;
    position: relative;
    overscroll-behavior: none; /* Prevents pull-to-refresh and scroll chaining */
  }

  body {
    font-family: ${theme.fonts.main};
    font-size: ${theme.fontSizes.medium};
    color: ${theme.colors.text};
    background-color: #1a1a1a; /* Dark background for desktop to contrast with mobile emulator */
    line-height: 1.5;
    height: 100%;
    width: 100%;
    overflow: hidden; /* Hide overflow on body level, let MobileEmulator handle it */
    position: relative;
    -webkit-overflow-scrolling: touch;
    /* Prevent text selection */
    -webkit-user-select: none;
    user-select: none;
  }

  #root {
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
  }

  img {
    -webkit-user-select: none; /* Safari/Chrome */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+ */
    user-select: none; /* Standard syntax */
    -webkit-touch-callout: none; /* iOS Safari */
  }

  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.heading};
    margin-bottom: ${theme.spacing.medium};
  }

  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      text-decoration: underline;
    }
  }

  button {
    cursor: pointer;
    font-family: ${theme.fonts.main};
    font-size: ${theme.fontSizes.medium};
    padding: ${theme.spacing.small} ${theme.spacing.medium};
    border: none;
    border-radius: 4px;
    background-color: ${theme.colors.primary};
    color: ${theme.colors.lightText};

    &:hover {
      opacity: 0.9;
    }

    &:focus {
      outline: none;
    }

    -webkit-tap-highlight-color: transparent;
  }

  /* Mobile specific styles */
  @media (max-width: ${theme.breakpoints.mobile}) {
    body {
      font-size: ${theme.fontSizes.small};
      background-color: ${theme.colors.background}; /* Normal background on actual mobile devices */
    }

    button,
    input[type="button"],
    input[type="submit"] {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      min-height: 44px; /* Better touch targets */
    }
  }

  /* App container styles - works within MobileEmulator */
  .App {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.background};
    position: relative;
    overflow: visible;

    /* Account for bottom menu */
    padding-bottom: calc(var(--bottom-menu-height) + var(--safe-area-inset-bottom));
  }

  .content-area {
    flex: 1;
    overflow: visible;
    position: relative;
  }

  /* Handle iPhone notch and safe areas */
  @supports (padding: max(0px)) {
    body {
      padding-top: min(0vmin, env(safe-area-inset-top));
      padding-left: min(0vmin, env(safe-area-inset-left));
      padding-right: min(0vmin, env(safe-area-inset-right));
      padding-bottom: min(0vmin, env(safe-area-inset-bottom));
    }
  }
`;

export default GlobalStyles;